import ExclamationMarkIcon from 'assets/images/icons/ExclamationMarkIcon.svg?react';
import { Tooltip } from 'components/ui/tooltip';
import { t } from 'utils/getTranslations';

interface DmsTeamStatusIndicatorProps {
    isValid: boolean | null;
}

export default function DmsTeamStatusIndicator({ isValid }: DmsTeamStatusIndicatorProps) {
    if (isValid === null || isValid === true) {
        return null;
    }

    return (
        <Tooltip content={t('teams.dms-team-invalid')}>
            <div
                data-testid="dms-team-invalid-icon"
                className="text-error inline-flex items-center"
                aria-label={t('teams.dms-team-invalid')}
            >
                <ExclamationMarkIcon width="16" height="16" />
            </div>
        </Tooltip>
    );
}
